const useHexToRgb = (hex) => {
    hex = hex.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    if (r === 0) {
      return ["00", g, b]
    }
    if (g === 0) {
      return [r, "00", b]
    }
    if (b === 0) {
      return [r, g, "00"]
    }
    return [r, g, b]
}

export default useHexToRgb